import { useTranslation } from 'react-i18next';

const AboutBanner = () => {
  const { t } = useTranslation('common');
  return (
    <section className="bg-cream py-8 md:py-12">
      <div className="container mx-auto px-0 md:px-8 lg:px-16">
        <div className="overflow-hidden rounded-lg shadow-md">
          <img
            src="/assets/imgs/About/Inner%20Pages_Picture_About_video.png"
            alt={t('about.bannerAlt')}
            className="w-full h-auto object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutBanner;
